import { RQParam, RQHandlers, RQService, RQApp } from '../../RQuery/RQuery';
import { dmHotel }                               from '../sign-in/xv-hotel';
import { MLText, mlBroker }                      from '../../services/MLText';
import { dmLoading }                             from '../loading/loading';

/*
    loading spinner components on page load completely fail for this view: (generate spurious
    tear-down exceptions that interfere with data rendering) - no clue why, looks like ionic
    bug - they have simply been removed. -l

*/

export class DetailsViewModel {
    BackToSignIn:     () => void;
    NewLoading:       (pMessage: string) => dmLoading;

    mlText:           MLText;
    app:              mlBroker;
    ml:               mlBroker;
    Hotel:            dmHotel;
    HotelDetails:     RQService.Ota.GetHotelDetailsRow;
    LangID:           number;

    HotelName:        string;

    AccommodationTypeParams = RQParam.OtaGetAccommodationTypesParams();
    AccommodationTypeList:    RQService.Ota.GetAccommodationTypesRow[];

    CurrencyList:             RQService.Ota.GetCurrenciesRow[];

    constructor(
         pMLText:       MLText
        ,pHotel:        dmHotel
        ,pBackToSignIn: () => void
        ,pNewLoading:   (pMessage: string) => dmLoading
    ) {
        this.mlText                         = pMLText;
        this.LangID                         = this.mlText.GetLangID();
        this.app                            = this.mlText.GetBroker(
            'BookingEngineAppTexts'
        );
        this.ml                             = this.mlText.GetBroker(
            'HotelAreaDetails'
        );

        this.Hotel                          = pHotel;
        this.BackToSignIn                   = pBackToSignIn;
        this.NewLoading                     = pNewLoading;

        this.AccommodationTypeParams.LangID = this.LangID;
        this.AccommodationTypeList          = [];
        this.CurrencyList                   = [];

        this.HotelDetails                   = RQService.Ota.PopulateGetHotelDetailsRow({});

        this.HotelName                      = this.Hotel.HotelInfo.HotelName;

        this.setAccommodationTypeListHandler();

        this.PopulateAccommodationTypeList(() => {
            this.PopulateHotelDetails(() => {
                this.PopulateCurrencies();
            });
        });
    }

    private setAccommodationTypeListHandler(): void {
        RQHandlers.Ota.GetAccommodationTypes = (result) => {
            let response = result as any;

            if (response.HasErrorOrException) { return; }

            let accommodationTypeList = response.RQueryResult;

            this.AccommodationTypeList.length = 0;

            for (let i = 0; i < accommodationTypeList.length; i++) {
                let accommodationType = RQService.Ota.PopulateGetAccommodationTypesRow(
                    accommodationTypeList[i]
                );

                console.log('row push');

                this.AccommodationTypeList.push(accommodationType);
            }
        };
    }

    public PopulateAccommodationTypeList(pAction: () => void): void {
        RQService.Ota.GetAccommodationTypes(
            this.AccommodationTypeParams
        ).then((result) => {
            pAction();
        });
    }

    public PopulateHotelDetails(pAction: () => void): void {
        let hotelDetailsParams     = RQParam.OtaGetHotelDetailsParams();
        
        hotelDetailsParams.HotelID = this.Hotel.HotelID;
        
        RQService.Ota.GetHotelDetails(
            hotelDetailsParams
        ).then((result) => {
            let response = result as any;
        
            if (response.HasErrorOrException) { return; }
        
            let hotelDetailsList = response.RQueryResult;
        
            this.HotelDetails = RQService.Ota.PopulateGetHotelDetailsRow(
                hotelDetailsList[0]
            );

            pAction();
        });
    }

    public PopulateCurrencies(): void {
        let currencyParams    = RQParam.OtaGetCurrenciesParams();

        currencyParams.LangID = this.LangID;

        RQService.Ota.GetCurrencies(
            currencyParams
        ).then((result) => {
            let response = result as any;

            if (response.HasErrorOrException) { return; }

            let currencies = response.RQueryResult;

            this.CurrencyList.length = 0;

            for (let i = 0; i < currencies.length; i++) {
                let currency = RQService.Ota.PopulateGetCurrenciesRow(
                    currencies[i]
                );

                console.log('row push');

                this.CurrencyList.push(currency);
            }
        });
    }

    public SignOut(): void {
        this.Hotel.SignOut((pLogOutResult) => { this.BackToSignIn(); });
    }

    public Save(): void {
        let loading = this.NewLoading(
            this.app.Text('SavingMark', 'Saving...')
        );

        loading.Show(() => {
            let saveParams = RQParam.OtaEditHotelDetailsParams();

            if (!this.HotelDetails.NrOfRooms) { this.HotelDetails.NrOfRooms = 0; }

            saveParams.HotelID             = this.Hotel.HotelID;
            saveParams.HotelName           = this.HotelName;
            saveParams.CPFirstName         = this.HotelDetails.CPFirstName;
            saveParams.CPLastName          = this.HotelDetails.CPLastName;
            saveParams.CPGender            = this.HotelDetails.CPGender;
            saveParams.Telephone           = this.HotelDetails.Telephone;
            saveParams.Fax                 = this.HotelDetails.Fax;
            saveParams.EmailGeneral        = this.HotelDetails.EmailGeneral;
            saveParams.EmailReservations   = this.HotelDetails.EmailReservations;
            saveParams.Web                 = this.HotelDetails.Web;
            saveParams.AccommodationTypeID = this.Hotel.HotelInfo.AccommodationTypeID;
            saveParams.CurrencyID          = this.HotelDetails.CurrencyID;
            saveParams.NrOfRooms           = Math.floor(this.HotelDetails.NrOfRooms);
            saveParams.LangID              = this.LangID;

            RQService.Ota.EditHotelDetails(saveParams).then((result) => {
                loading.Dismiss();

                let response = result as any;

                if (response.HasErrorOrException) {
                    this.PopulateHotelDetails(() => {
                        this.Hotel.RetrieveHotelDetails(() => { return; });
                    });
                }
            });
        });
    }
}


// WEBPACK FOOTER //
// ./src/pages/details/xv-details.ts